import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Row, Col, Carousel, Glyphicon } from 'react-bootstrap';
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import Filters from '../../new-order/filters/filters';
import Card from '../../new-order/card';
import {
    basketUpdate,
    basketUpdateLineItem,
    getNewOrders,
    downloadStockSheet,
    updateDeliveryAddress,
    getNewFeaturedProducts,
    emptyRepairBasket
} from '../../../actions/orders';
import ArrowButton from '../../common/button-arrow';
import ToastMessage from "../../common/toast-message";
import { getPromotionalBannersForNewOrderPage } from '../../../actions/promotional_banners';
import { getOutlets } from '../../../actions/outlet';
import Select from "../../common/form/elements/select";
import { getStockNotifications } from '../../../actions/stock-notifications';
import ImageSlider from '../../common/image-slider/image-slider';

import '../../new-order/styles.css';
import './order.css';

class Order extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmProduct: {},
            product_qty: 0,
            products_filtered: {},
            categories_ids: [],
            loadingProducts: true,
            products: {},
            product_search: '',
            filtering_cat: false,
            filtering_string: false,
            other_products_available: 0
        };
    }

    componentWillMount() {
        const { dispatch, stockNotificationsEnabled } = this.props;

        dispatch(emptyRepairBasket());
        dispatch(getOutlets(false, false))
        dispatch(getNewOrders()).then(() => {
            dispatch(getPromotionalBannersForNewOrderPage);
        });

        if (stockNotificationsEnabled) dispatch(getStockNotifications());
    }

    componentDidUpdate(prevProps) {
        const { dispatch, newOrderingEnabled, deliveryAddress } = this.props;

        if (newOrderingEnabled && prevProps.deliveryAddress !== deliveryAddress) {
            if (!!deliveryAddress) dispatch(getNewFeaturedProducts(deliveryAddress.id))
        }

        if (prevProps.products !== this.props.products) {
            this.filterFeatured();
        }

        if (this.props.repairedProduct !== prevProps.repairedProduct) {
            if (this.props.repairedProduct) {
                this.renderRepairProduct()
            } else {
                this.killRepairBox();
            }
        }

        if (document.getElementById('new-order').querySelector('#slider-container')) {
            document.getElementById('new-order').querySelector('#slider-container').addEventListener('scroll', this.scrollListener);
        }
    }

    componentWillUnmount = () => {
        if (document.getElementById('new-order').querySelector('#slider-container')) {
            document.getElementById('new-order').querySelector('#slider-container').removeEventListener('scroll', this.scrollListener);
        }
    }

    killRepairBox = () => {
        this.props.dispatch(emptyRepairBasket());
        if (document.getElementById('repair-product-node-clone')) {
            document.getElementById('repair-product-node-clone').parentElement.removeChild(document.getElementById('repair-product-node-clone'));
        }
        if (document.getElementById('repair-product-node-container')) {
            document.getElementById('repair-product-node-container').parentElement.removeChild(document.getElementById('repair-product-node-container'));
        }
        if (document.getElementById('repair-product-node-absolute')) {
            document.getElementById('repair-product-node-absolute').parentElement.removeChild(document.getElementById('repair-product-node-absolute'));
        }
        this.setState({
            repaired_product_quantity: null
        })
    }

    renderRepairProduct = () => {
        this.setState({
            repaired_product_quantity: this.props.repairedProduct.quantityIncrease
        })

        // first we find the slider container and clone within the image slider component
        let container = document.getElementById('new-order').querySelector('#slider-container');
        let clone = document.getElementById('new-order').querySelector('#slider-clone');

        // then we find the product card for both
        container = container.querySelector(`[data-id='${this.props.repairedProduct.id}']`);
        clone = clone.querySelector(`[data-id='${this.props.repairedProduct.id}']`);

        // we need to store the parent of the parent div of each of the product cards
        let parentContainer = container.parentNode.parentNode;
        let parentClone = clone.parentNode.parentNode;

        // we need to create a new element to place into the right place
        // we first create the container element as this is the element that has the correct width based on the image slider scroll bar
        // this is also to ensure the scroll bar moves down the correct amount of space
        const newChildNodeContainer = document.createElement('DIV');
        newChildNodeContainer.id = 'repair-product-node-container';
        newChildNodeContainer.style.width = '100%';
        newChildNodeContainer.style.padding = '0 4px';
        if (!document.getElementById('repair-product-node-container')) {
            parentContainer.parentNode.insertBefore(newChildNodeContainer, parentContainer.nextSibling)
            ReactDOM.render(this.renderRepairBox(), newChildNodeContainer);
        }

        // we then create the clone element to ensure we move the elements down the right amount of space
        // we use the actual width of the container repair block element to ensure it is the same height
        const newChildNodeClone = document.createElement('DIV');
        newChildNodeClone.id = 'repair-product-node-clone';
        newChildNodeClone.style.width = `${document.getElementById('repair-product-node-container').offsetWidth}px`;
        newChildNodeClone.style.padding = '0 4px';
        if (!document.getElementById('repair-product-node-clone')) {
            parentClone.parentNode.insertBefore(newChildNodeClone, parentClone.nextSibling)
            ReactDOM.render(this.renderRepairBox(), newChildNodeClone);
        }

        // we then create the actual element we will be using to modify the repair
        // this one is positioned absolutely outside of the scroller so that it does not scroll with the products
        let sliderWrapper = parentClone.parentNode;
        const absoluteElement = document.getElementById('repair-product-node-container').cloneNode(true);
        absoluteElement.id = 'repair-product-node-absolute';
        absoluteElement.style.position = 'absolute';
        absoluteElement.style.width = `${document.getElementById('repair-product-node-container').offsetWidth}px`;
        absoluteElement.style.top = `${newChildNodeContainer.offsetTop}px`;
        absoluteElement.style.left = '15px';
        absoluteElement.style.zIndex = '11';
        if (!document.getElementById('repair-product-node-absolute')) {
            sliderWrapper.parentNode.insertBefore(absoluteElement, sliderWrapper.parentNode.firstChild);
            ReactDOM.render(this.renderRepairBox(), absoluteElement);
        }
    }

    scrollListener = () => {
        this.killRepairBox();
    }

    renderRepairBox = () => {
        let product = this.props.products[this.props.repairedProduct.id];

        return (
            <div className="rep-repairs-box" id='repair-product-box'>
                <div className="rep-important-header">
                    <div className="rep-important-icon-container"><span>!</span></div>
                    <p>IMPORTANT: You have items in your order that you need to review.</p>
                </div>
                <p className="rep-main-text">
                    We can see this product has been repaired by your John Player Representative during their last two visits to your store. To ensure you have enough stock to meet consumer demand, we recommend you increase the quantity you are ordering by the amount of outers shown below. Add the additional quantity by clicking the button "Add Additional Outers". <b>If you do not wish to do so, please select "0" in the quantity picker below</b>
            </p>
                <div className="rep-product-container">
                    <div className="rep-product-repaired-container">
                        <div className="rep-product-repaired-image">
                            <img src={product.attributes.image} alt={product.attributes.name} />
                        </div>
                        <div className="rep-product-info-container">
                            <p className="header-highlight">This product has been repaired</p>
                            <p>{product.attributes.name}</p>
                        </div>
                    </div>
                    <div className="rep-product-quantity-container">
                        <input type="number" className="quantity-input" defaultValue={this.props.repairedProduct.quantityIncrease} value={this.state.repaired_product_quantity} onChange={e => this.updateRepairProductQuantity(e)} min={0} />
                    </div>
                </div>
                <div className="rep-button-container">
                    <ArrowButton color="green" submit={false} arrow={false} onClick={() => this.handleSubmitRepair()}>Add Additional Outers</ArrowButton>
                </div>
            </div>
        )
    }

    updateRepairProductQuantity = e => {
        this.setState({
            repaired_product_quantity: e.target.value
        })
    }

    handleSubmitRepair = () => {
        let newQuantity = Number(this.props.repairedProduct.originalQuantity) + Number(this.state.repaired_product_quantity);
        this.props.dispatch(basketUpdate({ id: this.props.repairedProduct.id }, newQuantity, { confirm: false }));
        this.setState({
            repaired_product_quantity: null
        })
    }


    handleConfirmation = (product, qty, fromConfirm = false, updateQuantity = false) => {
        const { deliveryAddress, newOrderingEnabled } = this.props
        if (qty < 1) {
            toast.error(<ToastMessage iconStyle="error"
                message="Please select a quantity" />);
            return Promise.resolve();
        } else {
            if (fromConfirm) {
                return this.props.dispatch(basketUpdateLineItem(this.props.basket.line_items[product.id], qty, fromConfirm));
            } else {
                if (newOrderingEnabled) {
                    return this.props.dispatch(
                        basketUpdate(
                            product,
                            qty,
                            {
                                confirm: false,
                                updateQuantity,
                                deliveryAddressId: deliveryAddress && deliveryAddress.id,
                                repairQuantity: !updateQuantity
                            }
                        )
                    );
                } else {
                    return this.props.dispatch(
                        basketUpdate(product, qty, { confirm: false, updateQuantity })
                    );
                }
            }
        }
    };

    handleDeliveryAddressChange(storeId) {
        this.props.dispatch(updateDeliveryAddress(storeId))
        this.props.dispatch(getNewFeaturedProducts(storeId))
    }

    basketContainsItems() {
        return (Object.keys(this.props.basket.line_items).length > 0)
    }

    renderDeliveryAddressSelector() {
        const { stores, defaultOutletId, deliveryAddress } = this.props
        let selectedStore = defaultOutletId
        if (selectedStore == null) {
            selectedStore = stores[0].id
        }
        if (this.basketContainsItems() && deliveryAddress) {
            selectedStore = deliveryAddress.id
        }

        const orderingStores = stores.filter(store => store.attributes.ordering)
        let selectorValues = orderingStores.map((store) => {
            return {
                value: store['id'],
                label: `${store.attributes.name} ${store.attributes['customer-number']}`
            }
        })

        return (
            <div className="order-now-container">
                <p>
                    In the section below you can find featured products that can be quickly added to your basket through the homepage. To view and choose from all of our offerings, please navigate to the Order Now page or use the search function below.<br /><br />Please ensure you select the correct store as a delivery address for this order. Once you add products to your basket and then wish to change your delivery address this will automatically start a new order.<br /><br />Once you have selected your store, you can start adding products to your basket by clicking on the product card in the section below.
              </p>
                <Select
                    disabled={this.basketContainsItems()}
                    onChange={(value) => this.handleDeliveryAddressChange(value)}
                    model='deep.delivery_store'
                    values={selectorValues}
                    selectedValue={selectedStore.toString()} />
            </div>
        )
    }

    renderBanner() {
        const { promotionalBanners } = this.props;
        return (
            <Carousel controls={promotionalBanners.promotional_banners.length > 1} indicators={promotionalBanners.promotional_banners.length > 1} interval={1000000}>
                {promotionalBanners.promotional_banners.map((promotionalBanner, key) => (
                    <Carousel.Item key={key}>
                        <div className="imgPreview">
                            <img src={promotionalBanner.attributes.links.image} />
                        </div>
                    </Carousel.Item>
                ))};
            </Carousel>
        );
    }

    renderProductCards = (products) => {
        this.setState({
            loadingProducts: true
        }, () => {
            let orderedProducts;
            orderedProducts = Object.keys(products).map((curr) => products[curr]);

            orderedProducts = orderedProducts.sort((a, b) => a.__index - b.__index).map((product) => {
                return {
                    inner:
                        <Col key={'product$' + product.id} data-id={product.id} className="product-row homepage-product-card">
                            <Card new_order_page={true} product={product} handleConfirmation={this.handleConfirmation} />
                        </Col>
                }
            });
            if (this.state.other_products_available > 0) {
                const orderLink = `/order/new?searchQuery=${this.state.product_search}&categoryIds=${this.state.categories_ids}`
                orderedProducts[orderedProducts.length] = {
                    inner: <Link className="product-row homepage-product-card other-products-card" to={orderLink}>{this.state.other_products_available} Other Products Available.<br />Click to View and Order now!</Link>
                }
            }
            this.setState({
                orderedProducts: orderedProducts,
                loadingProducts: false,
            })
        })
    }

    downloadCSV = () => {
        this.props.dispatch(downloadStockSheet());
    };

    handleProductSearch = e => {
        this.killRepairBox();
        if (e.target.value.length > 0) {
            this.setState({
                filtering_string: true,
                product_search: e.target.value
            }, () => {
                if (this.state.product_search.length > 0) {
                    this.filterString(this.state.product_search);
                } else {
                    this.setState({
                        products_filtered: {}
                    })
                }
            })
        } else {
            this.setState({
                filtering_string: false,
                product_search: '',
            }, () => {
                if (this.state.categories_ids.length > 0) {
                    this.filterCategories(this.state.categories_ids);
                } else {
                    this.setState({
                        products_filtered: {}
                    }, () => {
                        this.filterFeatured();
                    })
                }
            })
        }
    }

    filterString = filter => {
        let products_filtered;
        filter = filter.toLowerCase();
        products_filtered = Object.keys(this.props.products).map(product => {
            let brand = this.props.products[product].attributes.brand.toLowerCase();
            let category = this.props.products[product].attributes.category.toLowerCase();
            let name = this.props.products[product].attributes.name.toLowerCase();
            if (this.state.categories_ids.length > 0) {
                if ((brand.includes(filter) || category.includes(filter) || name.includes(filter)) && this.state.categories_ids.includes(this.props.products[product].attributes.category_id)) {
                    return this.props.products[product];
                };
            } else {
                if (brand.includes(filter) || category.includes(filter) || name.includes(filter)) {
                    return this.props.products[product];
                };
            }
        });
        this.filterProducts(products_filtered);
    }

    filterCategories = (categories_ids) => {
        this.killRepairBox();

        if (categories_ids.length > 0) {
            this.setState({
                filtering_cat: true,
                categories_ids: categories_ids
            }, () => {
                let products_filtered = Object.keys(this.props.products).map(product => {
                    if (this.state.product_search.length > 0) {
                        let brand = this.props.products[product].attributes.brand.toLowerCase();
                        let category = this.props.products[product].attributes.category.toLowerCase();
                        let name = this.props.products[product].attributes.name.toLowerCase();
                        if ((brand.includes(this.state.product_search) || category.includes(this.state.product_search) || name.includes(this.state.product_search)) && categories_ids.includes(this.props.products[product].attributes.category_id)) {
                            return this.props.products[product];
                        };
                    } else {
                        if (categories_ids.includes(this.props.products[product].attributes.category_id)) {
                            return this.props.products[product];
                        };
                    }
                });
                this.filterProducts(products_filtered);
            })
        } else {
            this.setState({
                filtering_cat: false,
                categories_ids: [],
            }, () => {
                if (this.state.product_search.length > 0) {
                    this.filterString(this.state.product_search);
                } else {
                    this.setState({
                        products_filtered: {}
                    }, () => {
                        this.filterFeatured();
                    })
                }
            })
        }
    }

    filterProducts = (products_filtered) => {
        products_filtered = products_filtered.filter(product => product !== undefined);
        products_filtered = products_filtered.reduce((result, item) => {
            result[item.id] = item;
            return result;
        }, {});
        this.setState({
            products_filtered: products_filtered
        }, () => {
            this.filterFeatured(products_filtered);
        })
    }

    filterFeatured = (products_filtered) => {
        this.setState({
            loadingProducts: true
        }, () => {

            let products, products_to_filter;
            if (!products_filtered) {
                products_to_filter = this.props.products;
            } else {
                products_to_filter = products_filtered;
            }
            let other_products_available = Object.keys(products_to_filter).length;
            products = Object.keys(products_to_filter).map(product => {
                if (products_to_filter[product].attributes.special_featured &&
                    products_to_filter[product].attributes.stock_status !== 'Out of Stock' &&
                    products_to_filter[product].attributes.stock_status !== 'Discontinued') {
                    return products_to_filter[product];
                };
            });
            products = products.filter(product => product !== undefined);
            products = products.reduce((result, item) => {
                result[item.id] = item;
                return result;
            }, {});
            other_products_available -= Object.keys(products).length;
            this.setState({
                products: products,
                products_filtered: products,
                other_products_available: other_products_available
            }, () => {
                this.renderProductCards(products);
            })
        })
    }

    render() {
        return (
            <div className="new-order" id='new-order'>
                <div className="container">
                    <h2>Order Now</h2>
                    {this.props.newOrderingEnabled &&
                        <Row>
                            <Col lg={12}>
                                {this.props.defaultOutletId && this.renderDeliveryAddressSelector()}
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col className="search-wrapper">
                            <div className="search-container">
                                <input type='text' name='product_search' value={this.state.product_search} onChange={(e) => this.handleProductSearch(e)} placeholder='Search by product category, product brand or product name' />
                                <Glyphicon glyph={'search'} />
                            </div>
                            <ArrowButton submit={false}
                                color={'grey'}
                                arrow={false}
                                className="pull-right"
                                onClick={this.downloadCSV}>Download Stock Sheet</ArrowButton>

                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Filters filterCategories={this.filterCategories} />
                        </Col>
                    </Row>
                    {this.props.possibleOrderLimit && (<div className="order-highlight">
                        Your tobacco products order may be subject to a maximum outer quantity limit. If this limit is reached, you will be notified when confirming your order
                    </div>)}
                </div>
                {this.state.loadingProducts ? (
                    <div className="text-center"><h2>Loading...</h2></div>
                ) : (
                    <ImageSlider
                        data={this.state.orderedProducts}
                        rows={2} />
                )}
            </div>
        )
    }
}

const mapStateToProps = ({
    orders: {
        new: {
            products,
            basket,
            confirmedProduct: confirmed,
            hideConfirm,
            contentUrl,
            possibleOrderLimit,
            deliveryAddress,
            newFeaturedProducts,
            repairedProduct
        }
    },
    promotionalBanners,
    viewConfig: { editContent, profile },
    stores: { stores },
    features: {
        new_ordering: newOrderingEnabled,
        stock_notifications: stockNotificationsEnabled
    }
}) => ({
    products,
    newFeaturedProducts,
    basket,
    confirmed,
    hideConfirm,
    contentUrl,
    editContent,
    possibleOrderLimit,
    promotionalBanners: promotionalBanners,
    stores,
    deliveryAddress,
    newOrderingEnabled,
    stockNotificationsEnabled,
    defaultOutletId: profile.attributes['default-outlet-id'],
    repairedProduct,
});

export default connect(mapStateToProps)(Order);



// WEBPACK FOOTER //
// ./src/components/home/order/order.jsx